module.exports = __webpack_public_path__ + "img/image_core01@2x.28b76f85.png";